var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-year"},[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleTabClick},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}},_vm._l((_vm.computedYearList),function(item){return _c('el-tab-pane',{key:item,attrs:{"label":item + '考研',"name":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }